module.exports = __webpack_public_path__ + "media/icons/plus-orange-11777ec1.svg";